export default __webpack_public_path__ + "static/media/kdw-logo.6f14764e.png";